/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import {Component, forwardRef, Input} from '@angular/core';
import {AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BooleanRadioGroupComponent),
  multi: true,
};
const customValidateProvider = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => BooleanRadioGroupComponent),
  multi: true,
};

@Component({
  selector: 'boolean-radio-group',
  template: `
    <div [formGroup]="dataForm">
      <mat-radio-group formControlName="booleanProperty" [disabled]="disabled">
        <div class="flex-layout-row flex-layout-gap-20px flex-align-start">
          <ng-container *ngIf="!reverseOrder; else reversed">
            <mat-radio-button [value]="true" [tabIndex]="startTabIndex !== undefined ? startTabIndex : null" [disabled]="disabled">
              {{ trueLabel }}
            </mat-radio-button>
            <mat-radio-button [value]="false" [tabIndex]="startTabIndex !== undefined ? startTabIndex + 1 : null" [disabled]="disabled">
              {{ falseLabel }}
            </mat-radio-button>
          </ng-container>
          <ng-template #reversed>
            <mat-radio-button [value]="false" [tabIndex]="startTabIndex !== undefined ? startTabIndex : null" [disabled]="disabled">
              {{ falseLabel }}
            </mat-radio-button>
            <mat-radio-button [value]="true" [tabIndex]="startTabIndex !== undefined ? startTabIndex + 1 : null" [disabled]="disabled">
              {{ trueLabel }}
            </mat-radio-button>
          </ng-template>
        </div>
      </mat-radio-group>
    </div>
  `,
  providers: [customValueProvider, customValidateProvider],
  standalone: false,
})
export class BooleanRadioGroupComponent implements ControlValueAccessor {
  @Input() trueLabel = 'Yes';
  @Input() falseLabel = 'No';
  dataForm: FormGroup;
  @Input() startTabIndex?: number;
  @Input() disabled = false;
  @Input() reverseOrder = false;
  @Input() buttonsHorizontal = true;
  writtenValue: boolean;

  constructor(fb: FormBuilder) {
    this.dataForm = fb.group({
      booleanProperty: [],
    });

    this.dataForm.valueChanges.subscribe(() => this.onFormChanged());
  }

  get booleanProperty(): AbstractControl {
    return this.dataForm.controls['booleanProperty'];
  }

  // required to propogate the changes to the consuming form
  onFormChanged() {
    this.propagateChange(this.booleanProperty.value);
    this.onTouched();
  }

  propagateChange: any = () => {};
  onTouched: any = () => {
    console.log('touched');
  };

  writeValue(booleanProperty: boolean): void {
    this.writtenValue = booleanProperty;
    this.setControlsFromWrittenValue();
  }

  private setControlsFromWrittenValue() {
    this.booleanProperty.setValue(this.writtenValue);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public validate(c: FormControl) {
    return null;
  }
}
